// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__cMABL","sign_sec":"style_sign_sec__NHmo4","sign_hero_wrap":"style_sign_hero_wrap__jQkiV","cont_form_wrap":"style_cont_form_wrap__ZOJxP"};